import { render } from "./FairOverview.vue?vue&type=template&id=507905b2&scoped=true"
import script from "./FairOverview.vue?vue&type=script&lang=js"
export * from "./FairOverview.vue?vue&type=script&lang=js"

import "./FairOverview.vue?vue&type=style&index=0&id=507905b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507905b2"]])

export default __exports__